/** * Created by mabiao on 2017/5/4. */

<style lang="less" rel="stylesheet/less">
@import '../../common/style/config.less';

.footerbar {
    position: fixed;
    bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    z-index: 50;
    width: 100%;
	max-width: 10rem;
	left: 0;
	right: 0;
	margin: 0 auto;
    // border-top: 1px solid #dddddd;
    background: #fff;
    display: flex;
    justify-content: center;
}

.footerbar .item {
    position: relative;
    display: inline-block;
    float: left;
    width: 25%;
    height: 1.547rem;
    color: #999;
    text-align: center;
    text-decoration: none;
}

.footerbar .item i {
    display: block;
    width: 1.547rem;
    height: 1.547rem;
    margin: 0 auto 0;
    background-repeat: no-repeat;
    background-size: 1.547rem 1.547rem;
}
.footerbar .item i.hot-icon {
    // background-image: url('@{IMAGE-PATH}tab_index_icon.png?@{DATE}');
    background-image: url('../../image/newVersion/tab_index_icon.png');
}

.footerbar .item i.listen-icon {
    background-image: url('@{IMAGE-PATH}listen.png?@{DATE}');
}

/**/
.footerbar .item i.ask-icon {
    background-image: url('../../image/newVersion/my_ask_icon.png');
}

.footerbar .item i.sc-icon {
    width: 0.827rem;
    height: 1.093rem;
    background-size: 100% 100%;
    background-image: url('@{IMAGE-PATH}sc.png?@{DATE}');
}

.footerbar .item i.course-icon {
    width: 1.600rem;
    height: 1.067rem;
    background-size: 100% 100%;
    background-image: url('@{IMAGE-PATH}kymj_tab.png?@{DATE}');
}

.footerbar .item i.mall-icon {
    // width: 0.680rem;
    // height: 1.067rem;
    background-size: 100% 100%;
    // background-image: url('@{IMAGE-PATH}mall_icon.png?@{DATE}');
    background-image: url('../../image/newVersion/mall_icon.png');
}

.footerbar .item i.presonal-icon {
    // background-image: url('@{IMAGE-PATH}me.png?@{DATE}');
    background-image: url('../../image/newVersion/icon_me.png');
}

.footerbar .item.current {
    color: #f85f48;
}

.footerbar .item.current i.hot-icon {
    // background-image: url('@{IMAGE-PATH}tab_indexAct_icon.png?@{DATE}');
    background-image: url('../../image/newVersion/tab_indexAct_icon.png');
}

.footerbar .item.current i.listen-icon {
    background-image: url('@{IMAGE-PATH}listen-active.png?@{DATE}');
}

.footerbar .item.current i.ask-icon {
    // background-image: url('@{IMAGE-PATH}my_ask_icon_act.png?@{DATE}');
    background-image: url('../../image/newVersion/my_ask_icon_act.png');
}

.footerbar .item.current i.sc-icon {
    background-image: url('@{IMAGE-PATH}sc_act.png?@{DATE}');
}

.footerbar .item.current i.mall-icon {
    // background-image: url('@{IMAGE-PATH}mall_icon_act.png?@{DATE}');
    background-image: url('../../image/newVersion/mall_icon_act.png');
}

.footerbar .item.current i.presonal-icon {
    // background-image: url('@{IMAGE-PATH}me-active.png?@{DATE}');
    background-image: url('../../image/newVersion/icon_me_active.png');
}

.unread-messages {
    position: absolute;
    width: 0.187rem;
    height: 0.187rem;
    border-radius: 50%;
    border: 0.027rem solid @mainColor;
    background: @mainColor;
    top: 0.133rem;
    right: 0.667rem;
}

/* 春节图标 */
.footerbar .item i.hot-icon.spring {
    background-image: url("../../image/newVersion/spring_tab1_select.png");
}

.footerbar .item.current i.hot-icon.spring {
    // background-image: url('@{IMAGE-PATH}tab_indexAct_icon.png?@{DATE}');
    background-image: url("../../image/newVersion/spring_tab1_selected.png");
}

.footerbar .item i.ask-icon.spring {
    background-image: url("../../image/newVersion/spring_tab2_select.png");
}

.footerbar .item.current i.ask-icon.spring {
    background-image: url("../../image/newVersion/spring_tab2_selected.png");
}

.footerbar .item i.mall-icon.spring {
    background-image: url("../../image/newVersion/spring_tab3_select.png");
}

.footerbar .item.current i.mall-icon.spring {
    background-image: url('../../image/newVersion/spring_tab3_selected.png');
}

.footerbar .item i.presonal-icon.spring {
    background-image: url("../../image/newVersion/spring_tab4_select.png");
}

.footerbar .item.current i.presonal-icon.spring {
    // background-image: url('@{IMAGE-PATH}me-active.png?@{DATE}');
    background-image: url('../../image/newVersion/spring_tab4_selected.png');
}


/* 年度老师图标 */
.footerbar .item i.hot-icon.ndls {
    background-image: url("../../image/newVersion/ndls_tab1_select.png");
}

.footerbar .item.current i.hot-icon.ndls {
    // background-image: url('@{IMAGE-PATH}tab_indexAct_icon.png?@{DATE}');
    background-image: url("../../image/newVersion/ndls_tab1_selected.png");
}

.footerbar .item i.ask-icon.ndls {
    background-image: url("../../image/newVersion/ndls_tab2_select.png");
}

.footerbar .item.current i.ask-icon.ndls {
    background-image: url("../../image/newVersion/ndls_tab2_selected.png");
}

.footerbar .item i.mall-icon.ndls {
    background-image: url("../../image/newVersion/ndls_tab3_select.png");
}

.footerbar .item.current i.mall-icon.ndls {
    background-image: url('../../image/newVersion/ndls_tab3_selected.png');
}

.footerbar .item i.presonal-icon.ndls {
    background-image: url("../../image/newVersion/ndls_tab4_select.png");
}

.footerbar .item.current i.presonal-icon.ndls {
    background-image: url('../../image/newVersion/ndls_tab4_selected.png');
}


.footerbar .item i.message-icon {
    background-image: url('../../image/newVersion/my_message_icon.png');
}

.footerbar .item.current i.message-icon {
    // background-image: url('@{IMAGE-PATH}my_ask_icon_act.png?@{DATE}');
    background-image: url('../../image/newVersion/my_message_icon_act.png');
}

.footerbar .item i.message-icon.ndls {
    background-image: url('../../image/newVersion/ndls_my_message_icon.png');
}

.footerbar .item.current i.message-icon.ndls {
    background-image: url('../../image/newVersion/ndls_my_message_icon_act.png');
}

.footerbar .item i.message-icon.spring {
    background-image: url('../../image/newVersion/spring_my_message_icon.png');
}

.footerbar .item.current i.message-icon.spring {
    background-image: url('../../image/newVersion/spring_my_message_icon_act.png');
}

.count-dot {
    min-width: 0.427rem;
    height: 0.427rem;
    line-height: 0.427rem;
    padding: 0 0.107rem;
    background-color: #EA3D4B;
    position: absolute;
    top: 0.333rem;
    right: 0.507rem;
    border-radius: 0.240rem;
    color: #ffffff;
    font-size: 0.320rem;
    font-weight: 600;
    border: 1px solid #ffffff;
}
.no-mall {
    .item {
        width: 25%;
    }
}
</style>
<template>
    <div class="footerbar" style="display:none;" :class="{'no-mall': isSwan}">
        <router-link to="/" class="item" :class="{current: current == 1}">
            <i
                class="hot-icon"
                ref="hotIcon"
            ></i
            ><!-- 首页 -->
        </router-link>
        <router-link @click.native="getLog('1531189023')" to="/consultIndex" class="item"
                     :class="{current: current == 2}">
            <i
                class="ask-icon"
                ref="askIcon"
            ></i
            ><!-- 提问 -->
        </router-link>
        <router-link to="/MeMessages?type=1" class="item"
                     :class="{current: current == 3}">
            <i
                class="message-icon"
                ref="messageIcon"
            ></i><!-- 消息 -->
            <div
                class="count-dot"
                v-if="messageCount"
            >{{ messageCount }}
            </div>
        </router-link>
        <router-link to="/meIndex" class="item" :class="{current: current == 4}">
            <i
                class="presonal-icon"
                ref="presonalIcon"
            ></i>
            <!-- 个人中心 -->
            <span class="unread-messages" v-if="isShowNoReadMsg"></span>
        </router-link>
    </div>
</template>
<script>
import {commonFn} from '../js/common.js';
import myAjax from '../js/request';
import {apiPath} from '../js/config';

export default {
    name: 'com-footer',
    data() {
        return {
            messageCount: 0,
            isSwan: commonFn.isSwan(),
        };
    },
    computed: {
        current() {
            return this.$store.state.curFooterPage;
        },
        isShowNoReadMsg() {
            return this.$store.state.noReadNums > 0 ? true : false;
        }
    },
    watch: {
        $route: {
            handler() {
                this.getMessageCount();
            }
        }
    },
    methods: {
        getLog(tag) {
            try {
                localStorage.setItem('tag', tag);
            } catch (e) {
            }
        },
        setSpringTabBarItem() {
            const {hotIcon, askIcon, messageIcon, mallIcon, presonalIcon} = this.$refs;
            if (!hotIcon || !askIcon || !messageIcon || !mallIcon || !presonalIcon) return;
            const itemList = [hotIcon, askIcon, messageIcon, mallIcon, presonalIcon];

            function addClass(name) {
                itemList.forEach(item => {
                    item.classList.add(name);
                });
            }

            if (this.isSpringTime()) {
                addClass('spring');
            }

            if (this.isNdlsTime()) {
                addClass('ndls');
            }
        },
        isSpringTime() {
            const nowTime = Date.now();
            //1673884800000 Tue Jan 17 2023 00:00:00 GMT+0800 (中国标准时间)
            //1675180800000 Wed Feb 01 2023 00:00:00 GMT+0800 (中国标准时间)
            return nowTime >= 1673884800000 && nowTime < 1675180800000;
        },
        isNdlsTime() {
            const nowTime = Date.now();
            return nowTime >= 1672934400000 && nowTime < 1673539200000;
        },

        getMessageCount: (function() {
            let loading = false;

            return async function() {
                if (loading) return;
                loading = true;

                try {
                    const res = await myAjax.get(apiPath.getNoticeNums, {
                        r: Math.random()
                    });
                    loading = false;
                    if (!res.message) {
                        this.messageCount = 0;
                        return;
                    }

                    this.messageCount = res.message > 99 ? '99+' : res.message;
                } catch (e) {
                }
                loading = false;
            };
        })(),
    },
    mounted() {
        this.setSpringTabBarItem();
        this.getMessageCount();
        window.addEventListener('pageshow', this.getMessageCount);
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.getMessageCount);
    }
};
</script>



// WEBPACK FOOTER //
// footer.vue?2e33c32c